import React from 'react';

import { UserContext } from 'client/components/UserContext';

const SignInButtonModal = ({
  onLoginSuccess = () => {},
  buttonText = 'Sign in',
  buttonClasses = 'btn btn-primary',
}: {
  onLoginSuccess: () => void;
  buttonText?: string;
  buttonClasses?: string;
}) => {
  const { showSignInModal } = React.useContext(UserContext);
  return (
    <button className={buttonClasses} onClick={() => showSignInModal(onLoginSuccess)} type="button">
      {buttonText}
    </button>
  );
};

export default SignInButtonModal;
